export default function Footer() {
    return(
        <div className="footer">
            <img src="/logo.jpg" alt="logo" />
            <div className="footer-text-flex">
                <p className="pp">
                Eng.youssef
                </p>
                <p>جميع حقوق الطبع والنشر © محفوظة 2025</p>
            </div>
            <a href="#nav"><i className="bx bx-chevrons-up"></i></a>
        </div>
    )
}